import React from "react";
import {Flex} from "../common_style/flex";
import {Span} from "../common_style/text";
import {FontStyles, Colors} from "../constants";
import CheeseburgerMenu from 'cheeseburger-menu';
import HamburgerMenu from 'react-hamburger-menu';
import SideMenu from '../side_menu';
import {Link} from "react-router-dom";
import {Localization} from "localizations/languages";

class AppBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
        };
    }

    openMenu() {
        this.preMenuLang = Localization.language;
        this.setState({menuOpen: true});
    }

    closeMenu() {
        this.setState({menuOpen: false});
        if (this.preMenuLang !== Localization.language) {
            window.location.reload();
        }
    }

    render() {
        return (<div style={{width: '100%'}}>
                <CheeseburgerMenu className={'burger-menu'} isOpen={this.state.menuOpen} closeCallback={this.closeMenu.bind(this)} width={400}>
                    <SideMenu closeMenu={() => this.closeMenu()} setRoute={(route) => this.setRoute(route)} onSetLanguage={(language) => this.setLanguage(language)}/>
                </CheeseburgerMenu>
                <Flex row hAlign={'stretch'} vAlign={'center'}
                      style={{marginTop: '25px', paddingLeft: '50px', paddingRight: '50px'}}>
                    <div style={{width: '200px', cursor: 'pointer'}}>
                        <HamburgerMenu
                            isOpen={this.state.menuOpen}
                            menuClicked={this.openMenu.bind(this)}
                            width={35}
                            height={25}
                            strokeWidth={4}
                            rotate={0}
                            color={Colors.button}
                            borderRadius={20}
                            animationDuration={0.5}
                        />
                    </div>
                    <div style={{flexGrow: 1, textAlign: 'center'}}>
                        <Span textStyle={FontStyles.title}>
                            {this.props.title}
                        </Span>
                    </div>
                    <div style={{width: '200px', height: '100%', display: 'flex', alignItems: 'center', justifySelf: 'center'}}>
                        {this.props.children}
                    </div>
                </Flex>
            </div>
        );
    }

    setLanguage(language) {
        this.setState({});
        Localization.setLanguage(language.key);
    }

    setRoute(route) {
        this.setState({ menuOpen: false });
        if (window.location.href.endsWith(route)) return;
        this.props.history.push(route);
    }
}

export default AppBar;